import * as React from "react";
import { Outlet } from "@tanstack/react-router";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { TRPCProvider } from "@/providers/TRPCProvider";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

/**
 * Root Layout Component
 *
 * This is the root layout for the entire application.
 * It wraps all pages with:
 * - ThemeProvider: Dark mode / theme switching
 * - TRPCProvider: tRPC + React Query context
 * - AuthProvider: Provides authentication context
 * - Toaster: Toast notifications (sonner)
 */
export function RootLayout() {
  return (
    <ThemeProvider>
      <TRPCProvider>
        <AuthProvider>
          {/* Main content outlet */}
          <Outlet />

          {/* Global toast notifications */}
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </TRPCProvider>
    </ThemeProvider>
  );
}
